import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, from } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';

import { OAuthService } from 'angular-oauth2-oidc';
import { GlobalErrorHandler } from './global-error.handler';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(private authService: OAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.authService.getAccessToken();
    // skip the request if it's not to the eakte+ API
    if (!req.url.includes('/eakteplus-document-metadata-api')) {
      console.warn('AuthInterceptor: skip request:', req.url);
      return next.handle(req)
    }

    if (!this.authService.hasValidAccessToken()) {
      console.warn('AuthInterceptor: token expired. refreshToken', req.url);
      return this.refreshToken().pipe(
        switchMap((newToken: string) => {
          console.warn('AuthInterceptor: token refreshed 35', req.url);
          if (this.authService.hasValidAccessToken()) {
            console.warn('AuthInterceptor: token valid 37', req.url);
            authReq = req.clone({
              setHeaders: { Authorization: `Bearer ${newToken}` }
            });
            return next.handle(authReq).pipe(
                catchError(error => {
                    console.warn('AuthInterceptor: error 43 before global handling', req.url, error);
                    if (GlobalErrorHandler.checkIfErrorIsUnauthorized(error)) {
                        console.warn('AuthInterceptor: error 45 before handle401Error', req.url, error);
                        // Handle expired token
                        return this.handle401Error(authReq, next);
                    }
                    return throwError(() => error);
                })
                );;
          } else {
            console.warn('AuthInterceptor: token invalid after refresh 53', req.url);
            // //logout
            //     console.error(`auth.interceptor before logout`);	
            //     this.authService.logOut(true);
            //     console.error(`auth.interceptor after logout`);	
            //     // this.router.navigate(['/authentication']);
            //     console.error(`auth.interceptor after navigate to authentication`);	
            //     this.authService.loadDiscoveryDocumentAndLogin();
            //     console.error(`auth.interceptor after loadDiscoveryDocumentAndLogin`);	
            //     this.authService.setupAutomaticSilentRefresh();
            //     console.error(`auth.interceptor after setupAutomaticSilentRefresh`);	
            console.error('Unable to refresh token, logging out.');	
            return throwError(() => new Error('Unable to refresh token, logging out.'));
          }
        })
      );
    }else if (token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    return next.handle(authReq).pipe(
      catchError(error => {
        console.warn('AuthInterceptor: error77 before global handling', req.url, error);
        if (GlobalErrorHandler.checkIfErrorIsUnauthorized(error)) {
          console.warn('AuthInterceptor: error 79 before handle401Error', req.url, error);
          // Handle expired token
          return this.handle401Error(authReq, next);
        }
        return throwError(() => error);
      })
    );
  }

private refreshToken(): Observable<string> {
    console.warn('AuthInterceptor: refreshToken called 89', this.isRefreshing, this.refreshTokenSubject);
    this.isRefreshing = true;
    this.refreshTokenSubject.next(null);

    // Convert Promise to Observable
    try{    
      if ((this.authService as any).tokenEndpoint === undefined ||
                  (this.authService as any).tokenEndpoint === null) {
        return from(this.authService.loadDiscoveryDocumentAndTryLogin()).pipe(
          switchMap(() => {
            console.warn('AuthInterceptor: loadDiscoveryDocumentAndTryLogin success 97', this.isRefreshing, this.refreshTokenSubject);
            return from(this.authService.refreshToken()).pipe(
                switchMap((tokenResponse: any) => {
                    this.isRefreshing = false;
                    const newToken = this.authService.getAccessToken();
                    this.refreshTokenSubject.next(newToken);
                    console.warn('AuthInterceptor: refreshToken success 104', this.isRefreshing, this.refreshTokenSubject);
                    return [newToken];
                }),
                catchError((err) => {
                    console.warn('AuthInterceptor: refreshToken failed 108', this.isRefreshing, this.refreshTokenSubject);
                    this.isRefreshing = false;
                    console.warn('AuthInterceptor: silentRefresh 110 failed authService.logOut()', this.isRefreshing, this.refreshTokenSubject);              
                    // this.authService.logOut(); // redirect to login
                    return throwError(() => new Error('Unable to refresh token, logging out.'));
                })
            );
          }
        ),catchError((err) => {
            console.warn('AuthInterceptor: loadDiscoveryDocumentAndTryLogin failed 119', this.isRefreshing, this.refreshTokenSubject);
            this.isRefreshing = false;
            console.warn('AuthInterceptor: loadDiscoveryDocumentAndTryLogin failed authService.logOut()', this.isRefreshing, this.refreshTokenSubject);
            // this.authService.logOut(); // redirect to login
            return throwError(() => new Error('Unable to refresh token, logging out.'));
          })
        );  
      }else{
        return from(this.authService.refreshToken()).pipe(
            switchMap((tokenResponse: any) => {
                this.isRefreshing = false;
                const newToken = this.authService.getAccessToken();
                this.refreshTokenSubject.next(newToken);
                console.warn('AuthInterceptor: refreshToken success 124', this.isRefreshing, this.refreshTokenSubject);
                return [newToken];
            }),
            catchError((err) => {
                console.warn('AuthInterceptor: refreshToken failed 128', this.isRefreshing, this.refreshTokenSubject);
                this.isRefreshing = false;
                console.warn('AuthInterceptor: silentRefresh 130 failed authService.logOut()', this.isRefreshing, this.refreshTokenSubject);              
                // this.authService.logOut(); // redirect to login
                return throwError(() => new Error('Unable to refresh token, logging out.'));
            })
        );
      }
    }catch(error){
          console.warn('AuthInterceptor: refreshToken failed 136', this.isRefreshing, this.refreshTokenSubject, error);                                  
          this.isRefreshing = false;
          console.warn('AuthInterceptor: refreshToken failed authService.logOut()', this.isRefreshing, this.refreshTokenSubject);
          // this.authService.logOut(); // redirect to login
          return throwError(() => new Error('Unable to refresh token, logging out.'));
    }
}

private handle401Error(req: HttpRequest<any>, next: HttpHandler) {
  console.warn('AuthInterceptor: handle401Error called 145', req.url);
    if (!this.isRefreshing) {
      console.warn('AuthInterceptor: handle401Error calling refreshToken 147', req.url);
        return this.refreshToken().pipe(
            switchMap((newToken: string) => 
                next.handle(
                    req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } })
                )
            )
        );
    } else {
      console.warn('AuthInterceptor: handle401Error reuse refreshToken 156', req.url);
        return this.refreshTokenSubject.pipe(
            filter(token => token != null),
            take(1),
            switchMap(token => next.handle(
                req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            ))
        );
    }
}
}
